(() => {
  const root = document.querySelector('[data-compatibility]');
  const data = window.ROAMUNO_DEVICE_COMPATIBILITY;
  if (!root || !data?.brands?.length) return;

  const form = root.querySelector('[data-compatibility-form]');
  const input = root.querySelector('[data-compatibility-input]');
  const result = root.querySelector('[data-compatibility-result]');
  const brandList = root.querySelector('[data-compatibility-brands]');
  const modelList = root.querySelector('[data-compatibility-models]');
  const resultCount = root.querySelector('[data-result-count]');
  const i18n = JSON.parse(document.querySelector('[data-compatibility-i18n]')?.textContent || '{}');
  const normalize = (value) => String(value || '').normalize('NFKD').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const aliases = {
    '苹果': 'iphone', '苹果手机': 'iphone', '三星': 'galaxy', '谷歌': 'pixel', '摩托罗拉': 'motorola',
    '小米': 'xiaomi', '红米': 'redmi', '索尼': 'xperia', '一加': 'oneplus', '荣耀': 'honor', '华为': 'huawei'
  };
  const normalizedQuery = (value) => {
    let query = normalize(value);
    Object.entries(aliases).forEach(([alias, replacement]) => { query = query.replace(alias, `${replacement} `); });
    return query.replace(/\s+/g, ' ').trim();
  };
  const models = data.brands.flatMap((brand, brandOrder) => brand.models.map((name, order) => ({
    name, brand: brand.name, platform: brand.platform, brandOrder, order
  })));
  let activeBrand = '';

  const format = (template, values) => Object.entries(values).reduce((text, [key, value]) => text.replaceAll(`%%${key}%%`, value), template);
  const score = (model, query) => {
    const name = normalize(model.name);
    const brand = normalize(model.brand);
    if (!query) return 1;
    if (name === query) return 100;
    if (`${brand} ${name}` === query) return 95;
    if (name.startsWith(query)) return 80;
    if (name.includes(query)) return 60;
    const tokens = query.split(' ').filter(Boolean);
    return tokens.every((token) => `${brand} ${name}`.includes(token)) ? 40 : 0;
  };

  const matchingModels = () => {
    const query = normalizedQuery(input?.value);
    return models
      .filter((model) => !activeBrand || model.brand === activeBrand)
      .filter((model) => query || activeBrand || model.order < 2)
      .map((model) => ({ ...model, score: score(model, query) }))
      .filter((model) => model.score > 0)
      .sort((a, b) => b.score - a.score || a.brandOrder - b.brandOrder || a.order - b.order);
  };

  const renderModels = () => {
    const matches = matchingModels();
    const query = normalizedQuery(input?.value);
    modelList.replaceChildren();
    resultCount.textContent = format(i18n.showing, { COUNT: String(matches.length) });
    matches.slice(0, activeBrand ? matches.length : query ? 30 : matches.length).forEach((model) => {
      const item = document.createElement('div');
      item.className = 'ru-compatibility__model';
      const name = document.createElement('strong');
      name.textContent = model.name;
      const brand = document.createElement('span');
      brand.textContent = model.brand;
      item.append(name, brand);
      modelList.append(item);
    });
  };

  const setActiveBrand = (brand) => {
    activeBrand = brand;
    input.value = '';
    result.hidden = true;
    brandList.querySelectorAll('button').forEach((button) => {
      const active = button.dataset.compatibilityBrand === activeBrand || (!activeBrand && !button.dataset.compatibilityBrand);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    renderModels();
  };

  const showModel = (model) => {
    result.replaceChildren();
    result.hidden = false;
    result.className = 'ru-compatibility__result ru-compatibility__result--listed';
    const status = document.createElement('span');
    status.textContent = i18n.listed;
    const title = document.createElement('h2');
    title.textContent = model.name;
    const meta = document.createElement('strong');
    meta.textContent = model.brand;
    const body = document.createElement('p');
    body.textContent = i18n.verify;
    result.append(status, title, meta, body);
    result.dataset.compatibilityCheck = 'listed';
    window.RoamUnoAnalytics?.track?.('compatibility_check', { result: 'listed', brand: model.brand });
  };

  const showNoMatch = () => {
    result.replaceChildren();
    result.hidden = false;
    result.className = 'ru-compatibility__result ru-compatibility__result--unknown';
    const title = document.createElement('h2');
    title.textContent = i18n.noMatch;
    const body = document.createElement('p');
    body.textContent = i18n.noMatchText;
    result.append(title, body);
    result.dataset.compatibilityCheck = 'unknown';
    window.RoamUnoAnalytics?.track?.('compatibility_check', { result: 'unknown' });
  };

  const submit = () => {
    const query = normalizedQuery(input?.value);
    const matches = matchingModels();
    if (!query || !matches.length) return showNoMatch();
    if (matches[0].score >= 95 || matches.length === 1) return showModel(matches[0]);
    result.replaceChildren();
    result.hidden = false;
    result.className = 'ru-compatibility__result ru-compatibility__result--choices';
    const title = document.createElement('h2');
    title.textContent = format(i18n.selectModel, { COUNT: String(matches.length) });
    result.append(title);
    input?.focus();
  };

  const allBrands = document.createElement('button');
  allBrands.type = 'button';
  allBrands.textContent = i18n.allBrands;
  allBrands.className = 'is-active';
  allBrands.setAttribute('aria-pressed', 'true');
  allBrands.addEventListener('click', () => setActiveBrand(''));
  brandList.append(allBrands);
  data.brands.forEach((brand) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = `${brand.name} (${brand.models.length})`;
    button.dataset.compatibilityBrand = brand.name;
    button.setAttribute('aria-pressed', 'false');
    button.addEventListener('click', () => setActiveBrand(brand.name));
    brandList.append(button);
  });
  form?.addEventListener('submit', (event) => { event.preventDefault(); submit(); });
  input?.addEventListener('input', () => { result.hidden = true; renderModels(); });
  renderModels();
})();
